export default __webpack_public_path__ + "static/media/allery-3.048f4e4d.svg";